module.exports = __webpack_public_path__ + "img/payment-img.063c5e7d.jpeg";